import styled from "@emotion/styled";

export const P = styled.p`
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "400"};
  width: ${(props) => props.textWidth || "100%"};
  text-align: ${(props) => props.textAlign || "center"};
  line-height: ${(props) => props.lineHeight || "1.3"};
  color: ${({ theme, color }) => color || theme.palette.text.primary};
`;

export const Span = styled.span`
  font-weight: ${(props) => props.fontWeight || "400"};
  font-size: ${(props) => props.fontSize || "14px"};
  color: ${({ theme, green }) =>
    green ? theme.palette.primary.main : theme.palette.text.primary};
`;

export const H4 = styled.h4`
  font-size: ${(props) => props.fontSize || "20px"};
  font-weight: ${(props) => props.fontWeight || "600"};
  color: ${({ theme, color }) => color || theme.palette.text.primary};
  text-align: ${(props) => props.textAlign || "center"};
  width: ${(props) => props.width || "100%"};
  position: ${(props) => props.position || ""};
  left: ${(props) => props.left || ""};
`;

export const H3 = styled.h3`
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "600"};
  text-align: ${(props) => props.align || "center"};
  margin: ${(props) => props.margin || "0"};
  line-height: 1.3;
  color: ${({ theme, color, gray, green }) =>
    color
      ? color
      : gray
      ? theme.palette.text.gray
      : green
      ? theme.palette.primary.main
      : theme.palette.text.primary};
`;

export const H2 = styled.h2`
  width: ${(props) => props.textWidth || "100%"};
  font-size: ${(props) => props.fontSize || "24px"};
  text-align: ${(props) => props.align || "center"};
  color: ${({ theme, green, color }) =>
    color || (green ? theme.palette.primary.main : theme.palette.text.primary)};
  font-weight: ${(props) => props.fontWeight || "600"};
  line-height: 1.3;
`;

export const H1 = styled.h1`
  width: 100%;
  font-size: ${(props) => props.fontSize || "28px"};
  text-align: ${(props) => props.align || "left"};
  color: ${({ theme, green, color }) =>
    color || (green ? theme.palette.primary.main : theme.palette.text.primary)};
  font-weight: 500;
  line-height: 1.3;

  @media (max-width: 820px) {
    font-size: ${(props) => props.fontSize || "24px"};
  }
`;

export const A = styled.a`
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "400"};
  width: ${(props) => props.textWidth || "auto"};
  text-align: ${(props) => props.textAlign || "center"};
  color: ${({ theme, color }) => color || theme.custom.link};

  &:hover {
    text-decoration: underline;
  }
`;

export const ScreenTitle = styled(P)`
  font-size: ${(props) => props.fontSize || "18px"};
  font-weight: ${(props) => props.fontWeight || "500"};
  width: ${(props) => props.width || "auto"};
  color: ${({ white, theme }) =>
    white ? theme.custom.white : theme.custom.grayDark};
`;

export const NotificationsTitle = styled.p`
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme, green, red }) =>
    green ? theme.palette.primary.main : red ? theme.palette.error.main : ""};
`;


